module.exports = __webpack_public_path__ + "img/background-main-credit.9df349ac.svg";